declare var $: any;
import { Component, OnInit, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'cj-grid',
  templateUrl: './cj-grid.component.html',
  styleUrls: []
})
export class CJGridComponent implements OnInit {

  @Input() columns: any[];
  @Input() buttons: any[];
  @Input() apiUrl: string;
  @Input() primaryKey: string;
  @Input() pageSize: number = 0;
  @Input() title: string = '';
  @Input() isExternalFilterPresent: boolean = false;
  @Input() preDefinedDataSource: any[] = [];
  @Input() pinnedBottomRowData: any[];
  @Input('doesExternalFilterPass') doesExternalFilterPass: (row: any) => any;

  busy: boolean = true;
  rows: any[] = [];
  dataSource: any[] = [];
  apiData: any[];
  totalPages: number = 0;
  currentPage: number = 0;
  searchText: string = '';
  searchTimeout: number = 0;
  public isLoading: boolean = false;
  constructor(
    private httpClient: HttpClient) {

  }

  ngOnInit() {
    this.loadData();
  }

  public loadData() {
    this.busy = true;
    this.totalPages = 0;
    this.currentPage = 0;
    this.dataSource = [];
    this.rows = [];

    this.getData().subscribe((res: any) => {
      if (res) {
        this.apiData = res;
        if (res.length < this.pageSize) {
          this.totalPages = 1;
        }
        else {
          this.totalPages = Math.floor(res.length / this.pageSize);
          if (res.length % this.pageSize > 0) {
            this.totalPages += 1;
          }
        }

        for (var v = 0; v < res.length; v++) {
          let row = [];
          for (var p = 0; p < this.columns.length; p++) {
            if (this.columns[p].cellRenderer) {
              let param = { data: res[v][this.columns[p].field], key: res[v][this.primaryKey] };
              var s = this.columns[p].cellRenderer(param);
              if (typeof s === 'object') {
                row.push(s.innerHTML);
              } else {
                row.push(s);
              }
            }
            else {
              if (this.columns[p].field) {
                if (this.columns[p].fieldType) {
                  var fieldValue = '';
                  switch (this.columns[p].fieldType) {
                    case 'currency':
                      fieldValue = '$' + res[v][this.columns[p].field];
                      break;
                    default:
                      fieldValue = res[v][this.columns[p].field];
                      break;
                  }
                  row.push(fieldValue);
                }
                else {
                  row.push(res[v][this.columns[p].field])
                }

              }
              else {
                if (this.columns[p].actionRenderer) {
                  let param = { data: res[v][this.primaryKey] };
                  let paramDetails = res[v];
                  var s = this.columns[p].actionRenderer(param, paramDetails);
                  row.push(s.innerHTML);
                }
              }
            }
          }
          this.dataSource.push(row);
        }

        let pagedDs = this.pageDataSource(this.dataSource, this.pageSize);
        this.rows = pagedDs[0];

      }
      this.busy = false;
    });
  }

  public getDataItem(key: string, keyValue: any ) {
    if (this.apiData.length > 0) {
      for (var i = 0; i < this.apiData.length; i++) {
        let data = this.apiData[i];
        if (data[key] == keyValue) return data;
      }
    }
    return null;
  }

  pageDataSource(arr, len) {
    var chunks = [], i = 0, n = arr.length;
    while (i < n) {
      chunks.push(arr.slice(i, i += len));
    }
    return chunks;
  }

  nextPage() {
    if (this.currentPage + 1 == this.totalPages) return;
    this.currentPage++;
    this.page();
  }

  prevPage() {
    if (this.currentPage == 0) return;
    this.currentPage--;
    this.page();
  }

  firstPage() {
    if (this.currentPage == 0) return;
    this.currentPage = 0;
    this.page();
  }

  lastPage() {
    if (this.currentPage + 1 == this.totalPages) return;
    this.currentPage = this.totalPages - 1;
    this.page();
  }

  page() {
    let pagedDs = this.pageDataSource(this.dataSource, this.pageSize);
    this.rows = pagedDs[this.currentPage];
  }

  search() {
    window.clearTimeout(this.searchTimeout);
    const self = this;

    this.searchTimeout = window.setTimeout(function () { self.beginSearch(); }, 500);
  }

  getData<T>() {
    return this.httpClient.get<T>(this.apiUrl);
  }

  beginSearch() {
    var filteredDs = [];
    for (var i = 0; i < this.dataSource.length; i++) {
      var row = this.dataSource[i];

      var keyFound = false;
      for (var a = 0; a < row.length; a++) {
        if (!keyFound) {
          if (row[a] != null) {
            var rowval = row[a].toString().toLowerCase();
            if (rowval.indexOf(this.searchText.toLowerCase()) != -1) {
              filteredDs.push(row);
              keyFound = true;
            }
          }
        }
      }
    }

    this.resetPaging(filteredDs);
  }

  sort(event) {
    let target = $(event)[0].currentTarget;
    let s = $(target);
    let colIndex = parseInt(s.attr('data-index'));
    if (s.hasClass('sort-desc')) {
      s.addClass('hide');
      s.next().removeClass('hide');
      this.dataSource.sort((a, b) => (a[colIndex] > b[colIndex]) ? 1 : -1);

    }
    else {
      s.addClass('hide');
      s.prev().removeClass('hide');
      this.dataSource.sort((a, b) => (a[colIndex] < b[colIndex]) ? 1 : -1);
    }

    this.resetPaging(this.dataSource);
  }

  resetPaging(dsource) {
    let pagedDs = this.pageDataSource(dsource, this.pageSize);
    this.currentPage = 0;
    this.totalPages = dsource.length < this.pageSize ? 1 : Math.round(dsource.length / this.pageSize);
    this.rows = pagedDs[0];
  }

  setUrl(url: string) {
    this.apiUrl = url;
  }

  public setQuickFilter(q: string) {
    this.searchText = q;
    this.beginSearch();
  }
}
